import { render, staticRenderFns } from "./ALoadConsumption.vue?vue&type=template&id=23c329cd&scoped=true"
import script from "./ALoadConsumption.vue?vue&type=script&lang=ts"
export * from "./ALoadConsumption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c329cd",
  null
  
)

export default component.exports